import { TreeTableComponent } from '@farris/ui-treetable';
import { FavoriteIcon, FAVORITE_FIELD_NAME } from '../lookup-displaytype';
import { LookupGridComponent } from '../lookup-grid.component';
import { cloneDeep } from 'lodash-es';
import { DataTableComponent } from '@farris/ui-datatable';

export class MultiSelectionManager {
    constructor(private ins: LookupGridComponent) {}

    onSelectedTableCellClick(e: any) {
        if (e.col.field === FAVORITE_FIELD_NAME) {
            e.event.stopPropagation();
            const classList = e.event.target['classList'];
            if (classList.contains('f-lookup-unfavorite') || classList.contains('f-icon-minus-circle')) {
                const rid =  e.row[this.ins.idField];
                this.ins.lookupSelectionSer.unSelect(rid);
                // åæ¶éä¸­ ä¸»åè¡¨ æ¶èåè¡¨ ä¸­çæ°æ®
                if (this.ins.isTree()) {
                    const tt = this.ins.lookupCmpMgr.getComponentInstance('treetable') as TreeTableComponent;
                    tt.unCheckedNode(rid);
                    tt.unSelectNode(rid);

                    if (this.ins.useFavorite) {
                        const _tt = this.ins.lookupCmpMgr.getComponentInstance('fav') as TreeTableComponent;
                        if (_tt && _tt.data && _tt.data.length && _tt.findRowNode(rid)) {
                            _tt.unCheckedNode(rid);
                            _tt.unSelectNode(rid);
                        }
                    }
                } else {
                    const dt = this.ins.lookupCmpMgr.getComponentInstance() as DataTableComponent;
                    dt.unCheckRow(rid);
                    if (this.ins.useFavorite) {
                        const _dt = this.ins.lookupCmpMgr.getComponentInstance('fav') as DataTableComponent;
                        if (_dt && _dt.data && _dt.data.length) {
                            _dt.unCheckRow(rid);
                        }
                    }
                }
            }
        }
    }

    /** åå§åå·²éæ°æ®åä¿¡æ¯ */
    initSelectedColumns() {
        let selectedColumns = [];
        if (this.ins.showSelected && !this.ins.singleSelect) {
            selectedColumns = cloneDeep(this.ins.gridOptions.columns.filter(n => n.field !== "__nodespagerbar__"));
            const favcol = selectedColumns.find(n => n.field === FAVORITE_FIELD_NAME);
            if (favcol) {
                favcol.formatter = () => {
                    return FavoriteIcon.remove;
                };
            } else {
                selectedColumns = selectedColumns.concat([
                    { field: FAVORITE_FIELD_NAME, width: 80, formatter: () => {
                            return FavoriteIcon.remove;
                        }
                    }
                ]);
            }
            this.ins.initColumnWidth(selectedColumns, 'sel');
        }

        return selectedColumns;
    }

    updateSelections(data) {
        if (Array.isArray(data)) {
            this.ins.lookupSelectionSer.updateSelections(data, true);
        } else {
            this.ins.lookupSelectionSer.select(data);
        }
    }

    remove(id: any) {
        if (id) {
            this.ins.lookupSelectionSer.unSelect(id);
        }
    }

    deleteSelectedItems(data: any) {
        if (!data || !data.length) {return;}
        this.ins.lookupSelectionSer.updateSelections(data, false);

        if (!this.ins.isShow) {return;}
        const ids = data.map(n => n[this.ins.idField]);
        if (this.ins.isTree()) {
            const tt = this.ins.lookupCmpMgr.getComponentInstance('treetable') as TreeTableComponent;
            tt&& tt.unCheckedAndSelected(ids);

            if (this.ins.useFavorite) {
                const _tt = this.ins.lookupCmpMgr.getComponentInstance('fav') as TreeTableComponent;
                _tt && _tt.unCheckedNodes(ids, true, false);
            }

        } else {
            const dt = this.ins.lookupCmpMgr.getComponentInstance() as DataTableComponent;
            dt && dt.unCheckRows(ids);
            if (this.ins.useFavorite) {
                const _dt = this.ins.lookupCmpMgr.getComponentInstance('fav') as DataTableComponent;
                _dt && _dt.unCheckRows(ids);
            }
        }
    }


    clear() {
        this.ins.lookupSelectionSer.clearSelections();

        if (!this.ins.isShow) {return;}

        if (this.ins.isTree()) {
            const tt = this.ins.lookupCmpMgr.getComponentInstance('treetable') as TreeTableComponent;
            tt&&tt.clearAll();

            if (this.ins.useFavorite) {
                const _tt = this.ins.lookupCmpMgr.getComponentInstance('fav') as TreeTableComponent;
                _tt&&_tt.clearAll();
            }

        } else {
            const dt = this.ins.lookupCmpMgr.getComponentInstance() as DataTableComponent;
            dt&&dt.clearSelections();
            if (this.ins.useFavorite) {
                const _dt = this.ins.lookupCmpMgr.getComponentInstance('fav') as DataTableComponent;
                _dt&&_dt.clearSelections();
            }
        }
    }

    save(rows: any) {
        if (this.ins.showSelected) {
            this.ins.personalConf.selections = rows;
            this.ins.personalConfigService.savePersonalConfig(this.ins.personalConf);
        }
    }

    loadData() {
        let items = this.ins.personalConf ? (this.ins.personalConf.selections || []) : [];
        if (!items.length) {
            items = this.ins.lookupSelectionSer.getSelections();
        }
        this.ins.lookupSelectionSer.loadSelections(items);
    }
}
